import { Button } from '@/components/atoms/Button/Button.styled';
import { medias } from '@/utils/sizes';
import { generateClampFromMax } from '@/utils/styling';
import styled from 'styled-components';

export const Footer = styled.footer``;

export const SocialLinks = styled.ul`
  display: grid;
  grid-template-columns: 100%;
  list-style-type: none;
`;

export const FooterContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: nowrap;
  gap: 10px;
  padding-bottom: var(--spacing-component-inner);

  .log-in {
    margin-left: ${generateClampFromMax(60)};
  }

  img {
    margin-right: ${generateClampFromMax(30)};
  }

  ${medias.max.desktopSm} {
    flex-wrap: wrap;

    .logo-container-link {
      flex-basis: 100%;
    }
  }

  ${medias.max.tablet} {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding-top: var(--spacing-component-inner-lg);
    grid-column-gap: var(--spacing-component-inner-xs);
    grid-row-gap: var(--spacing-component-inner-lg);
    padding-bottom: var(--spacing-component-inner-lg);

    .logo-container-link {
      grid-column: span 3;
    }

    .log-in {
      margin-left: 0;
    }
  }

  ${medias.max.mobile} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    border-top: 1px solid var(--c-border);
    padding-bottom: 50px;
    grid-row-gap: 20px;

    br {
      display: none;
    }

    br[data-mobile] {
      display: block;
    }

    .logo-container-link {
      grid-column: span 2;
    }

    .email {
      grid-column: span 2;
    }

    button {
      position: relative;
      display: contents;
      height: auto;

      &:before {
        content: '';
        position: absolute;
        height: 44px;
        width: 100%;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    a {
      position: relative;

      &:before {
        content: '';
        position: absolute;
        height: 44px;
        width: 100%;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    ${SocialLinks} {
      grid-template-columns: repeat(2, 1fr);
      grid-column: span 2;
      grid-column-gap: var(--spacing-component-inner-xs);
    }
  }

  ${Button} {
    align-items: flex-start;
    justify-content: flex-start;
  }
`;
